var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 12.7237C11.25 12.8159 11.1359 12.859 11.0749 12.7898L9.06293 10.5044C8.78922 10.1935 8.31531 10.1634 8.00441 10.4371C7.69351 10.7108 7.66336 11.1847 7.93707 11.4956L11.4586 15.4956C11.6015 15.6579 11.8075 15.7507 12.0238 15.75C12.2401 15.7493 12.4455 15.6553 12.5875 15.4922L16.0659 11.4922C16.3377 11.1796 16.3047 10.7059 15.9922 10.4341C15.6796 10.1623 15.2059 10.1953 14.9341 10.5078L12.9255 12.8176C12.8648 12.8874 12.75 12.8445 12.75 12.752V6C12.75 5.58579 12.4142 5.25 12 5.25C11.5858 5.25 11.25 5.58579 11.25 6V12.7237ZM6 13.25C6.41421 13.25 6.75 13.5858 6.75 14V16C6.75 16.6904 7.30964 17.25 8 17.25H16C16.6904 17.25 17.25 16.6904 17.25 16V14C17.25 13.5858 17.5858 13.25 18 13.25C18.4142 13.25 18.75 13.5858 18.75 14V16C18.75 17.5188 17.5188 18.75 16 18.75H8C6.48122 18.75 5.25 17.5188 5.25 16V14C5.25 13.5858 5.58579 13.25 6 13.25Z",
    fill: "#626B7F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadWhite);
export default __webpack_public_path__ + "static/media/download-white.e1122cd5440259d96a1178f2c4dfb279.svg";
export { ForwardRef as ReactComponent };